import React, { Component } from 'react';
import { PlayerAvatar, PlayerMeta, PlayerFeedback } from '../../cards';
import './MatchSquadPlayer.css';

class MatchSquadPlayer extends Component {
	constructor(props) {
		super(props);
	}
	componentDidMount() {}
	componentWillUnmount() {}
	onGoalChange = val => {
		if (typeof val === 'undefined' || val === '') {
			val = '0';
		}
		this.props.onGoalChange(val, this.props.playerReport);
	};
	onCardChange = val => {
		if (typeof val === 'undefined' || val === '') {
			val = '0';
		}
		this.props.onCardChange(parseInt(val, 10), this.props.playerReport);
	};
	onReviewChange = val => {
		this.props.onTextChange(val, this.props.playerReport);
	};
	onPositionChange = val => {
		this.props.onPositionChange(this.props.positions[val], this.props.playerReport);
	};
	onRatingChange = val => {
		this.props.onRatingChange(val, this.props.playerReport);
	};

	render() {
		return (
			<div className="flexContainerRow matchSquadPlayer grey2">
				<div className="item-1 white">
					<PlayerAvatar
						firstName={this.props.player.firstName}
						surname={this.props.player.surname}
						avatar={this.props.player.playerAvatar}
					/>
				</div>
				<div className="item-1">
					<PlayerMeta
						player={this.props.player}
						playerReport={this.props.playerReport}
						positions={this.props.positions}
						onPositionChange={this.onPositionChange}
						cards={this.props.cards}
						cardValue={this.props.cardValue}
						onCardChange={this.onCardChange}
						goals={this.props.goals}
						goalValue={this.props.goalValue}
						onGoalChange={this.props.onGoalChange}
					/>
				</div>
				<div className="item-2 white grey1-border">
					<PlayerFeedback
						playerReport={this.props.playerReport}
						onRatingChange={this.onRatingChange}
						onReviewChange={this.onReviewChange}
					/>
				</div>
			</div>
		);
	}
}
export { MatchSquadPlayer };



// WEBPACK FOOTER //
// ./src/components/layouts/matchSquadPlayer/MatchSquadPlayer.js